import { AsyncState } from '../../../../constants/types';
import { GetOrganizationQuery } from '../../../../generated/gql';
import { useIntegratedQuery } from '../../../../hooks/useIntegratedQuery';

import GET_ORGANIZATION from '../../graphql/getOrganization';

export function useOrganization(): AsyncState<string> {
  const queryResult = useIntegratedQuery<GetOrganizationQuery>(
    GET_ORGANIZATION,
    'community',
    {
      fetchPolicy: 'cache-first',
    },
  );

  return {
    loading: queryResult.loading,
    error: queryResult.error,
    data: queryResult.data?.getOwner,
  };
}
